import React from "react";
import Layout from "layout";

export default function RateSettings() {
  const thirdPartyServices = [
    {
      name: "Simple Swap",
      url: "https://partners.simpleswap.io",
      description: "Partner platform for crypto exchange services"
    },
    {
      name: "Changenow",
      url: "https://changenow.io/affiliate",
      description: "Affiliate program for instant crypto exchange"
    }
  ];

  return (
    <Layout>
      <div className="dashboard-main">
        <div className="main-wrapper max-w-5xl p-6">
          <h1 className="text-2xl font-bold mb-2">Earning Fee</h1>
          <p className="text-gray-600 mb-8">Fee Configuration</p>
          
          <div className="space-y-4">
            <h2 className="text-lg font-semibold mb-4">Open the links below to configure fees</h2>
            
            {thirdPartyServices.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow"
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-800 mb-2">
                      {service.name}
                    </h3>
                    <p className="text-sm text-gray-600 mb-3">
                      {service.description}
                    </p>
                    <a
                      href={service.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-cyan-600 hover:text-cyan-700 font-medium text-sm break-all"
                    >
                      {service.url}
                    </a>
                  </div>
                  <div className="ml-4">
                    <a
                      href={service.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center px-6 py-3 bg-cyan-600 hover:bg-cyan-700 text-white font-semibold rounded-lg transition-colors shadow-sm"
                    >
                      Open
                      <svg
                        className="w-4 h-4 ml-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
